<template>
  <Card shoaw class="script-edit">
    <div class="content">
      <div class="">
        <ScriptShow ref="ScriptShow"></ScriptShow>
        <Row class="title">
          <h4 :style="{float: 'left'}">{{ title }}</h4>
        </Row>
        <Alert v-if="scriptError" type="warning" show-icon>获取脚本数据失败</Alert>
        <Form ref="scriptForm" :model="scriptForm" :label-width="60" :rules="scriptRule" v-else>
          <FormItem label="名称" prop="name">
            <Input v-model="scriptForm.name" :maxlength="100" />
          </FormItem>
          <FormItem label="类型" prop="type">
            <RadioGroup v-model="scriptForm.type" @on-change="typeChange">
              <Radio :label="item.value" v-for="(item, index) in allTypeData" :key="index">{{ item.label }}</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="脚本" prop="content">
            <codemirror ref="myCm" v-model="scriptForm.content" :options="cmOptions"></codemirror>
          </FormItem>
          <FormItem label="描述" prop="desc">
            <Input v-model="scriptForm.desc" :maxlength="1000" />
          </FormItem>
          <FormItem>
            <div style="float: right">
              <Button type="primary" @click="changeSubmit">提交</Button>
              <Button style="margin-left: 8px" @click="getData" v-show="$route.params.id">重置</Button>
              <Button style="margin-left: 8px" @click="back">取消</Button>
            </div>
          </FormItem>
        </Form>
        <div v-if="$route.params.id">
          <Row class="title" :style="{marginTop: '15px'}">
            <h4 :style="{float: 'left'}">历史版本</h4>
          </Row>
          <Row>
            <Alert v-if="versionHistory.error" type="warning" show-icon>获取版本历史数据失败</Alert>
            <Table
              v-else
              border
              size="small"
              :height="0"
              ref="table"
              :data="versionHistory.data"
              :columns="versionHistory.columns">
            </Table>
            <div style="margin: 10px 0; overflow: hidden;">
              <div style="float: right;">
                <page
                  :total="versionHistory.count"
                  :current="versionHistory.page"
                  :page-size="versionHistory.size"
                  @on-change="getVersionHistory"></page>
              </div>
            </div>
          </Row>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import { changeOpsCenterScript, detailOpsCenterScript, getScriptVersionHistory } from '@/api/opscenter'
import { cmOptions, scriptTypeChange } from './scriptTools'
import ScriptShow from './script-show'
import codemirror from './scriptUse.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/foldgutter.js'
import 'codemirror/addon/fold/foldcode.js'
import 'codemirror/addon/edit/closebrackets.js' // 自动闭合符号
import 'codemirror/addon/edit/matchbrackets.js' // 匹配结束符号，比如"]、}"
export default {
  name: 'script-edit',
  components: {
    codemirror,
    ScriptShow
  },
  data () {
    return {
      scriptForm: {
        id: this.$route.params.id ? this.$route.params.id : 0,
        name: '',
        desc: '',
        type: 'shell',
        content: ''
      },
      scriptError: false,
      title: this.$route.params.id ? '编辑脚本' : '添加脚本',
      scriptRule: {
        name: { required: true, message: '脚本名称不能为空', trigger: 'blur' },
        content: { required: true, message: '脚本内容不能为空', trigger: 'blur' }
      },
      allTypeData: [
        { 'value': 'shell', 'label': 'shell' },
        { 'value': 'python', 'label': 'python' },
        { 'value': 'linuxyml', 'label': 'linux-yml' },
        { 'value': 'winyml', 'label': 'win-yml' },
        { 'value': 'winps1', 'label': 'powershell' }
      ],
      versionHistory: {
        data: [],
        columns: [
          {
            title: '版本ID',
            align: 'center',
            minWidth: 190,
            key: 'version_id'
          },
          {
            title: '创建用户',
            align: 'center',
            minWidth: 120,
            key: 'user_full_name'
          },
          {
            title: '创建时间',
            align: 'center',
            minWidth: 150,
            key: 'created_format'
          },
          {
            title: '操作',
            width: 130,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$refs.ScriptShow.openModal(params.row)
                    }
                  }
                }, '查看'),
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.scriptForm.type = params.row.type
                      this.scriptForm.content = params.row.content
                      this.typeChange(this.scriptForm.type)
                      this.$Notice.info({
                        title: '提示',
                        desc: '该版本的脚本已还原到输入框中，点击提交后生效!'
                      })
                    }
                  }
                }, '使用')
              ])
            }
          }
        ],
        error: false,
        count: 0,
        page: 1,
        size: 10
      },
      cmOptions: cmOptions
    }
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.getData()
        this.getVersionHistory()
      } else {
        this.scriptForm = {
          id: this.$route.params.id ? this.$route.params.id : 0,
          name: '',
          desc: '',
          type: 'shell',
          content: ''
        }
      }
    }
  },
  created: function () {
    if (this.$route.params.id) {
      this.getData()
      this.getVersionHistory()
    }
  },
  computed: {
    myCodeMirror () {
      let editor = this.$refs.myCm.editor
      editor.on('keypress', function () { // 监听输入，自动弹出代码智能提示
        editor.showHint({
          completeSingle: false // 关闭在只有一个选项时自动完成拼写
        })
      })
      return editor
    }
  },
  methods: {
    // 获取脚本数据
    getData () {
      this.scriptError = false
      detailOpsCenterScript(this.$route.params.id).then(res => {
        this.scriptForm.name = res.data.name
        this.scriptForm.desc = res.data.desc
        this.scriptForm.type = res.data.type
        this.scriptForm.content = res.data.content
        this.typeChange(this.scriptForm.type)
      }).catch(res => {
        this.scriptError = true
        this.$Notice.error({ title: '获取脚本数据失败' })
      })
    },
    // 编辑提交
    changeSubmit () {
      this.$refs['scriptForm'].validate((valid) => {
        if (valid) {
          changeOpsCenterScript(this.scriptForm, this.scriptForm.id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.$router.push({
              name: 'script_detail',
              params: { id: res.data['id'] }
            })
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
          })
        } else {
          this.$Notice.warning({
            title: '请检查输入框！'
          })
        }
      })
    },
    typeChange (value) {
      const lang = scriptTypeChange(value)
      this.myCodeMirror.setOption('mode', { name: lang })
    },
    back () {
      this.$router.go(-1)
    },
    getVersionHistory (value = 1) {
      this.versionHistory.page = value
      let params = {
        size: this.versionHistory.size,
        page: this.versionHistory.page,
        script: this.$route.params.id
      }
      getScriptVersionHistory(params).then(res => {
        this.versionHistory.data = res.data.results
        this.versionHistory.count = res.data.count
      }).catch(res => {
        this.versionHistory.data = []
        this.versionHistory.count = 0
        this.versionHistory.error = true
        this.$Notice.error({ title: '获取版本历史数据失败' })
      })
    }
  }
}
</script>

<style lang="less">
  .CodeMirror{
    font-size: 15px;
  }
  .CodeMirror-gutters {
    /*border-left: 4px solid #9A9A9A;*/
  }
  .CodeMirror-fullscreen {
    z-index: 999 !important;
  }
  .CodeMirror-hints {
    z-index: 1000 !important;
  }
</style>
